"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
const base_1 = require("./base");
const helper_1 = require("./helper");
const configureFramework = (Session) => (0, base_1.configureFramework)(Session, (0, helper_1.getCookieDomain)('openbank.es'), 'OK_ES', 'es-ES');
exports.configureFramework = configureFramework;
//# sourceMappingURL=index.js.map